import Vue from 'vue'
import Router from 'vue-router'
import store from '../store/index'
import storeModuleUser from '../store/modules/user'
import Calc from '../components/Calc'
import Admin from '../components/Admin'
import Orders from '../components/Orders'
import Order from '../components/Order'
import Calendar from '../components/Calendar'
import Import from '../components/Import'
import { Roles } from '../enums'

Vue.use(Router)

// const ifAuthenticated = (to, from, next) => {
//   if (storeModuleUser.state.token) {
//     next()
//     return
//   }
//   next('/')
// }

const checkRole = (roles) => {
  return (to, from, next) => {
    if (storeModuleUser.state.token) {
      store.dispatch('user/fetchProfile').then(() => {
        const userRoles = storeModuleUser.state.user ? storeModuleUser.state.user.roles : []
        if (userRoles.filter(r => (roles.concat([Roles.ADMIN])).includes(r)).length > 0) {
          next()
        }
      })
    } else {
      next('/')
    }
  }
}

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/calc'
    },
    {
      path: '/calc',
      component: Calc
    },
    {
      path: '/admin',
      component: Admin,
      beforeEnter: checkRole([Roles.MANAGER])
    },
    {
      path: '/orders',
      name: 'orders',
      component: Orders,
      beforeEnter: checkRole([Roles.USER, Roles.MANAGER])
    },
    {
      path: '/order/:uuid',
      name: 'order',
      component: Order,
      beforeEnter: checkRole([Roles.USER, Roles.MANAGER]),
      props: true
    },
    {
      path: '/calendar',
      component: Calendar,
      beforeEnter: checkRole([Roles.USER]),
      props: true
    },
    {
      path: '/import',
      component: Import,
      beforeEnter: checkRole([Roles.MANAGER])
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js